<template>
  <div class="contentBox">
    <div class="breadCrumbs mt-50">
      <el-breadcrumb separator="/" class="ml-15">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>Research</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="researchBox">
      <div v-html="research"></div>
    </div>
  </div>
</template>
<script>
import apiSign from "../assets/js/apiSign";

export default {
  data() {
    return {
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      research:''
    };
  },
  computed: {
    formattedZoom() {
      return Number.parseInt(this.scale * 100);
    }
  },
  mounted() {
    // this.getPdf();
    this.getresearchFn()
  },
  watch: {
    show: function(s) {
      if (s) {
        this.getresearchFn();
      }
    },
    page: function(p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    }
  },
  methods: {
    getresearchFn() {
      let field = { rtime: apiSign.getTime() };
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/app/research", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          this.research = resp.data.data.research
        });
    },
    findPos(obj) {
      return obj.offsetTop;
    }
  }
};
</script>

<style>
.pdfBox {
  max-height: 500px;
  overflow-y: scroll;
}
.pdfDom {
  width: 100%;
  margin: 20px auto;
}
.researchBox {
  padding: 20px;
  background: #fff;
  border-radius: 5px;
}
.researchBox img{
  max-width: 100%;
}
#buttons {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
/* Page content */
.content {
  padding: 16px;
}
</style>

